import { render } from "./TrashIcon.vue?vue&type=template&id=2fceb195&ts=true"
import script from "./TrashIcon.vue?vue&type=script&lang=ts"
export * from "./TrashIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__